import React from 'react';
import './Home.css'
import Bed from '../../assets/icons/double-bed.png';
import Bath from '../../assets/icons/bath-icon.png';
import Ruler from '../../assets/icons/ruler-icon.png';
import Resize from '../../assets/icons/resize-icon.png';
import Realtor from '../../assets/icons/realtor.jpg'
const Home = () => {
  return (
    <section id='info' className='home section'>
        <div className='section_title'>
            Home Information and Amenities
        </div>
        <div className='house-container container'>

            <div className='house-info'>
                <div className='house-address'>
                2 Franklin Ave, London, ON N6C 2G7
                </div>
                <div className='house-price'>$ 1,130,000</div>
                <div className='house-figures'>
                    <div className='house-item'>
                        <img src={Bed} className='item_img' alt=''/>
                        <p>4</p>
                        <p className='small-text'>Bed(s)</p>
                    </div>
                    
                    <div className='house-item'>
                        <img src={Bath} className='item_img' alt='' />
                        <p>4</p>
                        <p className='small-text'>Bed(s)</p>
                    </div>

                    <div className='house-item'>
                        <img src={Ruler} className='item_img' alt='' />
                        <p>2,512</p>
                        <p className='small-text'>SQFT</p>
                    </div>

                    <div className='house-item'>
                        <img src={Resize} className='item_img' alt=''/>
                        <p>4</p>
                        <p className='small-text'>Lot (Acres)</p>
                    </div>
                </div>

                <div className='house-description'>
                <p>From the moment you enter this light bathed, energy efficient custom home to the time you depart, you will be amazed by the beauty and warmth that envelopes you.</p>
                <p>With heated bamboo floors, soaring ceilings, well designed & welcoming spaces inside, and wonderful woodlands &open spaces out, located conveniently to Lawrence or access to I-70, you will be awestruck by it's beauty. Large woodshop, tractor barn, picnic shelter with cabin overlooking pond, Lovely!</p>
                </div>
            </div>

            {/* Agent infomation */}
            <div className='agent-info'>
                <div className='image'>
                    <img src={Realtor} className='realtor_img' alt=''/>
                </div>
                <h3>Agent's name</h3>
                <p className='agent-company'>Agency Organization</p>
                <div className='line'></div>
                <div className='phone-number'><a className='phone'>+1 (647) 466-9999</a></div>
                <div className='agent-contact'>
                    <a className='agent-email' href="#">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" id="email" fill='var(--text-color-darker)'><path d="M34.05 50 9 66.31V33.69L34.05 50zm31.9 0L91 66.31V33.69L65.95 50zm-3.66 2.39-11.2 7.29c-.33.21-.71.32-1.09.32s-.76-.11-1.09-.32l-11.2-7.29L10.66 70l-1.57 1.02C9.58 73.84 12.04 76 15 76h70c2.96 0 5.42-2.15 5.91-4.98L89.33 70 62.29 52.39zM50 55.61 89.33 30l1.58-1.02C90.42 26.15 87.96 24 85 24H15c-2.96 0-5.42 2.16-5.91 4.98L10.66 30 50 55.61z"></path></svg>
                    </a>
                    <a className='agent-facebook' href="#">
                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" fill='var(--text-color-darker)' viewBox="0 0 24 24" id="facebook">< path d="M20.9,2H3.1A1.1,1.1,0,0,0,2,3.1V20.9A1.1,1.1,0,0,0,3.1,22h9.58V14.25h-2.6v-3h2.6V9a3.64,3.64,0,0,1,3.88-4,20.26,20.26,0,0,1,2.33.12v2.7H17.3c-1.26,0-1.5.6-1.5,1.47v1.93h3l-.39,3H15.8V22h5.1A1.1,1.1,0,0,0,22,20.9V3.1A1.1,1.1,0,0,0,20.9,2Z"></path></svg>
                    </a>
                    <a className='agent-instagram' href="#">
                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" fill='var(--text-color-darker)' viewBox="0 0 24 24" id="instagram"><path d="M12,9.52A2.48,2.48,0,1,0,14.48,12,2.48,2.48,0,0,0,12,9.52Zm9.93-2.45a6.53,6.53,0,0,0-.42-2.26,4,4,0,0,0-2.32-2.32,6.53,6.53,0,0,0-2.26-.42C15.64,2,15.26,2,12,2s-3.64,0-4.93.07a6.53,6.53,0,0,0-2.26.42A4,4,0,0,0,2.49,4.81a6.53,6.53,0,0,0-.42,2.26C2,8.36,2,8.74,2,12s0,3.64.07,4.93a6.86,6.86,0,0,0,.42,2.27,3.94,3.94,0,0,0,.91,1.4,3.89,3.89,0,0,0,1.41.91,6.53,6.53,0,0,0,2.26.42C8.36,22,8.74,22,12,22s3.64,0,4.93-.07a6.53,6.53,0,0,0,2.26-.42,3.89,3.89,0,0,0,1.41-.91,3.94,3.94,0,0,0,.91-1.4,6.6,6.6,0,0,0,.42-2.27C22,15.64,22,15.26,22,12S22,8.36,21.93,7.07Zm-2.54,8A5.73,5.73,0,0,1,19,16.87,3.86,3.86,0,0,1,16.87,19a5.73,5.73,0,0,1-1.81.35c-.79,0-1,0-3.06,0s-2.27,0-3.06,0A5.73,5.73,0,0,1,7.13,19a3.51,3.51,0,0,1-1.31-.86A3.51,3.51,0,0,1,5,16.87a5.49,5.49,0,0,1-.34-1.81c0-.79,0-1,0-3.06s0-2.27,0-3.06A5.49,5.49,0,0,1,5,7.13a3.51,3.51,0,0,1,.86-1.31A3.59,3.59,0,0,1,7.13,5a5.73,5.73,0,0,1,1.81-.35h0c.79,0,1,0,3.06,0s2.27,0,3.06,0A5.73,5.73,0,0,1,16.87,5a3.51,3.51,0,0,1,1.31.86A3.51,3.51,0,0,1,19,7.13a5.73,5.73,0,0,1,.35,1.81c0,.79,0,1,0,3.06S19.42,14.27,19.39,15.06Zm-1.6-7.44a2.38,2.38,0,0,0-1.41-1.41A4,4,0,0,0,15,6c-.78,0-1,0-3,0s-2.22,0-3,0a4,4,0,0,0-1.38.26A2.38,2.38,0,0,0,6.21,7.62,4.27,4.27,0,0,0,6,9c0,.78,0,1,0,3s0,2.22,0,3a4.27,4.27,0,0,0,.26,1.38,2.38,2.38,0,0,0,1.41,1.41A4.27,4.27,0,0,0,9,18.05H9c.78,0,1,0,3,0s2.22,0,3,0a4,4,0,0,0,1.38-.26,2.38,2.38,0,0,0,1.41-1.41A4,4,0,0,0,18.05,15c0-.78,0-1,0-3s0-2.22,0-3A3.78,3.78,0,0,0,17.79,7.62ZM12,15.82A3.81,3.81,0,0,1,8.19,12h0A3.82,3.82,0,1,1,12,15.82Zm4-6.89a.9.9,0,0,1,0-1.79h0a.9.9,0,0,1,0,1.79Z"></path></svg>
                    </a>
                    <a className='agent-twitter' href="#">
                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" fill='var(--text-color-darker)'viewBox="0 0 24 24" id="twitter"><path d="M22,5.8a8.49,8.49,0,0,1-2.36.64,4.13,4.13,0,0,0,1.81-2.27,8.21,8.21,0,0,1-2.61,1,4.1,4.1,0,0,0-7,3.74A11.64,11.64,0,0,1,3.39,4.62a4.16,4.16,0,0,0-.55,2.07A4.09,4.09,0,0,0,4.66,10.1,4.05,4.05,0,0,1,2.8,9.59v.05a4.1,4.1,0,0,0,3.3,4A3.93,3.93,0,0,1,5,13.81a4.9,4.9,0,0,1-.77-.07,4.11,4.11,0,0,0,3.83,2.84A8.22,8.22,0,0,1,3,18.34a7.93,7.93,0,0,1-1-.06,11.57,11.57,0,0,0,6.29,1.85A11.59,11.59,0,0,0,20,8.45c0-.17,0-.35,0-.53A8.43,8.43,0,0,0,22,5.8Z"></path></svg>
                    </a>
                    <a className='agent-website' href="#"><i className='bx bx-link-external' ></i></a>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Home
